import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { HeaderTwo } from 'secondstep-components'

export const Description = styled.span``

export const DescriptionWrapper = styled.div``

export const LeftBoxWrapper = styled.div`
  flex-direction: column;
`

export const StyledHeaderTwo = styled(HeaderTwo)``

export const Users = styled.span`
  font-family: ${themeGet('font.molde.medium')};
`
